import { FunctionComponent } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppDispatch } from "../../Redux/store/hooks";
import editimage from "../Image/Edit.svg";
import { useNavigate } from "react-router-dom";
import { Switch } from "@mui/material";
import { edit_EditableValueStrategies } from "../../Redux/Reducers/Strategies_api/editableValuStrategies";
import { Strategiesvalues_datagrid } from "../../Redux/Reducers/Datagrid-values/Strategies-values-slicer";
import { DeleteStrategiesvalues_datagrid } from "../../Redux/Reducers/Datagrid-values/DeleteStrategies-values-slicer";

interface AlgoMessageProps {
  valuepopup: number;
  editdata: any;
}

const StrategyMessage: FunctionComponent<AlgoMessageProps> = (props: any) => {
  const dispatcher = useAppDispatch();
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const pageName = "View Strategies";
  const valueit = sessionStorage.getItem("permission");
  const menuList: any = JSON.parse(
    valueit === null
      ? localStorage.getItem("permission") || "null"
      : sessionStorage.getItem("permission") || "null"
  );
  const test_val = menuList
    .map((data: any) => {
      return data.sub_menus.filter((child: any) => {
        return child.name === pageName;
      });
    })
    .filter((final: any) => {
      return final.length > 0;
    })
    .reduce((retus: any, currentarray: any) => {
      return currentarray;
    }, {});
  const MenuOfUserpermission = test_val[0];

  return (
    <div
      style={{
        display: "flex",
        // flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {MenuOfUserpermission?.permission?.edit ? (
        <span
          title={
            props.editdata.isMatch === true
              ? "Algo or strategy is currently used in tradesetup"
              : "Status Active / Inactive"
          }
        >
          <Switch
            disabled={props.editdata.isMatch === true}
            {...label}
            size="small" // Add this line to set the switch size to small
            checked={props.editdata.is_enabled} // Set the checked prop based on the state
            onChange={(e) => {
              const dataToPass = props.editdata; // Replace with your actual data
              localStorage.setItem("filter", dataToPass.id);
              dispatcher(
                Strategiesvalues_datagrid({
                  is_enabled: e.target.checked,
                })
              );
            }}
          />
        </span>
      ) : (
        "-"
      )}
      {MenuOfUserpermission?.permission?.edit ? (
        <span
          title={
            props.editdata.isMatch === true
              ? "Algo or strategy is currently used in tradesetup"
              : "Edit"
          }
          style={{ cursor: "pointer" }}
          onClick={() => {
            const dataToPass = props.editdata;
            localStorage.setItem("filter", dataToPass.id);
            dispatcher(edit_EditableValueStrategies(props.editdata));
            navigate("/addstrategies", {
              state: { editoradd: "edit", Tradecheck: props.editdata.isMatch },
            });
          }}
        >
          <img src={editimage} width="25px" alt={""}></img>
        </span>
      ) : (
        "-"
      )}
      {MenuOfUserpermission?.permission?.delete ? (
        <DeleteIcon
          titleAccess="Delete"
          sx={{
            color: "rgb(239, 153, 15)",
            cursor: "pointer",
          }}
          onClick={(e) => {
            dispatcher(
              DeleteStrategiesvalues_datagrid({
                id: props.valuepopup,
              })
            );
          }}
        ></DeleteIcon>
      ) : (
        "-"
      )}
    </div>
  );
};

export default StrategyMessage;
